import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import type { LocationOption } from '@/constants/translations';

const KEYS = {
  countries: ['locations', 'countries'] as const,
  cities: (country: string) => ['locations', 'cities', country] as const,
  districts: (country: string, city: string) => ['locations', 'districts', country, city] as const,
};

export function useCountries() {
  return useQuery<LocationOption[]>({
    queryKey: KEYS.countries,
    queryFn: async () => {
      const { data } = await api.get<LocationOption[]>('/api/providers/locations/countries/');
      return data;
    },
    staleTime: 10 * 60 * 1000,
  });
}

export function useCities(country: string) {
  return useQuery<LocationOption[]>({
    queryKey: KEYS.cities(country),
    queryFn: async () => {
      const { data } = await api.get<LocationOption[]>('/api/providers/locations/cities/', {
        params: { country },
      });
      return data;
    },
    enabled: !!country,
    staleTime: 10 * 60 * 1000,
  });
}

export function useDistricts(country: string, city: string) {
  return useQuery<LocationOption[]>({
    queryKey: KEYS.districts(country, city),
    queryFn: async () => {
      const { data } = await api.get<LocationOption[]>('/api/providers/locations/districts/', {
        params: { country, city },
      });
      return data;
    },
    enabled: !!country && !!city,
    staleTime: 10 * 60 * 1000,
  });
}
